<template>
  <div v-if="rankingData" class="box bg-white">
    <div class="head f-b-c">
      <div>{{ rankingData.title }}</div>
      <el-button v-if="rankingData.is_detail" type="text" @click="lookInfo">查看详细信息</el-button>
    </div>
    <div class="data-list">
      <el-table
        :data="rankingData.tableData"
        style="width: 100%">
        <el-table-column
          v-if="rankingData.type === 'banner'"
          label="Banner图"
          min-width="150">
          <template v-slot="{ row }">
            <el-popover placement="right" width="340" trigger="hover">
              <el-image :src="row.imgUrl" fit="cover" />
              <el-image slot="reference" :src="row.imgUrl" fit="cover" style="width: 60px;height: 35px" />
            </el-popover>
          </template>
        </el-table-column>
        <el-table-column
          v-else-if="rankingData.type.includes('product')"
          prop="name"
          label="产品信息"
          min-width="200">
          <div slot-scope="{row}" class="f--c">
            <el-popover placement="right" width="280" trigger="hover">
              <el-image :src="row.imgUrl" fit="cover" />
              <el-image slot="reference" :src="row.imgUrl" fit="cover" style="width: 36px;height: 36px" />
            </el-popover>
            <div class="info">
              <el-tooltip class="item" effect="dark" :content="row.productName" placement="top">
                <div style="width:90%;font-size: 14px" class="ellipsis">{{ row.productName }}</div>
              </el-tooltip>
              <div style="font-size: 12px;color: #454545;">
                SPU：
                <copy :text="row.spuCode" />
              </div>
            </div>
          </div>
        </el-table-column>
        <el-table-column
          v-else-if="rankingData.type === 'page'"
          label="页面路径"
          min-width="200">
          <template slot-scope="{row}">
          <el-button  type="text"  @click="jumpView(row.fullPath)">
             <span class="jump">{{row.fullPath}}</span>
            </el-button>
        </template>
        </el-table-column>
        <el-table-column
          v-else-if="rankingData.type === 'visitor'"
          prop="name"
          label="来源"
          min-width="190">
        </el-table-column>
        <el-table-column
          v-else-if="rankingData.type === 'visitor1'"
          prop="name"
          label="国家/地区"
          min-width="190">
        </el-table-column>
        <el-table-column
          v-else
          prop="name"
          label="名称"
          min-width="150">
          <template v-slot="{ row }">
            <el-tooltip class="item" effect="dark" :content="row.name" placement="top">
              <div style="width:90%;font-size: 14px" class="ellipsis">{{ row.name }}</div>
            </el-tooltip>
          </template>
        </el-table-column>

        <template v-if="rankingData.type === 'page'">
          <el-table-column
            prop="browseQty"
            label="浏览量"
            min-width="80"
            align="right">
          </el-table-column>
          <el-table-column
            prop="userTotal"
            label="浏览用户数"
            min-width="80"
            align="right">
          </el-table-column>
          <el-table-column
            prop="rate"
            label="跳出率"
            min-width="80"
            align="right">
            <template v-slot="{ row }">
              <span>{{ row.rate*100 | round }}%</span>
            </template>
          </el-table-column>
        </template>
        <template v-else-if="rankingData.type.includes('visitor')">
          <el-table-column
            prop="visitorQty"
            label="访客"
            min-width="80"
            align="right">
          </el-table-column>
          <el-table-column
            prop="progress"
            label="占比"
            min-width="200">
            <template v-slot="{ row }">
              <el-progress :text-inside="true" :stroke-width="16" :percentage="row.rate*100 | round"></el-progress>
            </template>
          </el-table-column>
        </template>
        <template v-else>
          <el-table-column
            prop="browseQty"
            label="浏览量"
            min-width="76"
            align="right">
          </el-table-column>
          <el-table-column
            prop="clickQty"
            label="点击量"
            min-width="76"
            align="right">
          </el-table-column>
          <el-table-column
            prop="rate"
            label="点击率"
            min-width="70"
            align="right">
            <div slot-scope="{row}" class="f-e-c">
              {{ row.rate*100 | round }}%
            </div>
          </el-table-column>
        </template>
      </el-table>
    </div>
  </div>
</template>

<script>
import copy from '@/components/copy.vue'
import _ from 'lodash'
export default {
  components: { copy },
  props: {
    rankingData: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
    }
  },
  methods: {
    lookInfo() {
      // if (this.rankingData.type.includes('visitor')) {
      if (this.rankingData.open_detail) {
        this.$emit('lookInfo', this.rankingData)
        return
      }
      this.$router.push({
        path: this.rankingData.path,
        query: {
          startTime: this.rankingData.chartTime[0].valueOf(),
          endTime: this.rankingData.chartTime[1].valueOf()
        }
      })
    },
    jumpView(url){//
      window.open(process.env.VUE_APP_KAKACLO_URL+url);//打开新网页跳转至新网页
    }
  },
}
</script>

<style lang="scss" scoped>
.box {
  min-width: 400px;
  padding: 20px;
  .head {
    div {
      font-size: 16px;
    }

    /deep/ .el-button--text {
      padding: 0;
    }
  }
  .jump:hover{
    text-decoration: underline;
  }
  .data-list {
    .info {
      width: 100%;
      margin-left: 6px;
    }
  }
}
</style>